var React = require('react');

function Golf (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("path",{"d":"M12.5 8.5V16M8 11.5V16M14.75 19v5.25M5.75 24.25V19M3.5 19H17M19.25 8.5H12.5V5.716a1.5 1.5 0 0 1 .879-1.366l5.25-2.386a1.5 1.5 0 0 1 2.121 1.365V7a1.5 1.5 0 0 1-1.5 1.5zM2.75 11.5H8V9.475a1.5 1.5 0 0 0-.891-1.371l-3.75-1.667A1.5 1.5 0 0 0 1.25 7.808V10a1.5 1.5 0 0 0 1.5 1.5z"}))));
}

Golf.defaultProps = {"width":"22","height":"25","viewBox":"0 0 22 25"};

module.exports = Golf;

Golf.default = Golf;
